module.exports = __webpack_public_path__ + "img/acc_carousel_01.ed8be75c.jpg";